// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3OSXq","range":"MonthRangeSwitch_range__3K-tY","disabled":"MonthRangeSwitch_disabled__27Une"};